module.exports = __webpack_public_path__ + "static/media/gift-special.29f4b405.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/gift-special.jpg
// module id = 462
// module chunks = 0